var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_23817)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.293,
    cy: 27,
    r: 21,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4583 33.1794V33.1788H35.4617V28.1954C35.4617 25.7574 34.9368 23.8794 32.0867 23.8794C30.7165 23.8794 29.7971 24.6313 29.4217 25.3441H29.382V24.107H26.6797V33.1788H29.4936V28.6868C29.4936 27.5041 29.7178 26.3604 31.1825 26.3604C32.6257 26.3604 32.6472 27.7101 32.6472 28.7627V33.1794H35.4583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 24.1084H24.9169V33.1802H22.0996V24.1084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5087 19.5884C22.6079 19.5884 21.877 20.3193 21.877 21.2201C21.877 22.1209 22.6079 22.8671 23.5087 22.8671C24.4095 22.8671 25.1404 22.1209 25.1404 21.2201C25.1398 20.3193 24.4089 19.5884 23.5087 19.5884V19.5884Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_23817",
    x: 0.445312,
    y: 0.394531,
    width: 57.6953,
    height: 57.6953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.24219
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.92383
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_23817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_23817",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5882,
    height: 13.5882,
    fill: "white",
    transform: "translate(21.877 19.5884)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0ad47981e6257292e8a0ff33d1ed8e38.svg";
export { ForwardRef as ReactComponent };